import DataTable from "react-data-table-component";
import tableCustomStyles from "../common/CustomeStyle";
import Loader from "../common/Loader/Loader";
import sortIcon from "../../resources/images/sort.svg";
const OnBoardTable = ({ pending, onBoardData,columns, handleSort}) => {
 
  return (
    <DataTable
      columns={columns}
      data={onBoardData?.results}
      customStyles={tableCustomStyles}
      highlightOnHover
      pointerOnHover
      striped
      progressPending={pending}
      progressComponent={
        <Loader height={50} width={50} color={"#5382ba"} center={true} />
      }
      onSort={handleSort}
      sortServer
      persistTableHead
      responsive
      fixedHeader
      fixedHeaderScrollHeight="90vh"
      sortIcon={<img src={sortIcon} alt="sort" />}
    />
  );
};

export default OnBoardTable;
